import { setContentGroups, ContentGroups } from 'lib/GoogleAnalytics';
import { useEffect } from 'react';

export function useContentGroups(contentGroups: ContentGroups): void {
  useEffect(() => {
    setContentGroups(contentGroups);
  }, [contentGroups]);
}
